import { injectReducer } from "store/reducers";

import ChooseRoute from "./routes/Choose";

import NoMatch from "NoMatch";
import component from "./components";
import Module from "./modules/LoginModule";
import Platform from "./routes/Platform";
import ThirdPartyAuth from "./routes/ThirdPartyAuth";
import OauthV2 from "./routes/OauthV2";
import PageNotFound from "./routes/PageNotFound";
import MigrationInProgress from "./routes/MigrationInProgress";
import ToddleLibrary from "./routes/ToddleLibrary";
import UserBlocked from "./routes/UserBlocked";
import SchoolLogin from "./routes/SchoolLogin";
import AppLauncher from "./routes/AppLauncher";
import AppDownload from "./routes/AppDownload";
import MobileUnsupportedRedirect from "./routes/MobileUnsupportedRedirect";
import FamilyRedirect from "./routes/FamilyRedirect";
import StudentRedirect from "./routes/StudentRedirect";
import TeacherRedirect from "./routes/TeacherRedirect";
import Admissions from "./routes/Admissions";
import AITutorAwardsDeepLink from "./routes/AITutorAwardsDeepLink";
import AITutorAwardsNominateDeepLink from "./routes/AITutorAwardsNominateDeepLink";
import SessionRevoke from "./routes/SessionRevoke";

export const createRoutes = store => {
  injectReducer(store, { key: "login", reducer: Module });
  const teacherReducer = require("Teacher/modules/TeacherModule").default;
  injectReducer(store, { key: "teacher", reducer: teacherReducer });

  const messagingV2Module = require("MessagingV2/modules/MessagingModule");
  injectReducer(store, {
    key: messagingV2Module.NAME,
    reducer: messagingV2Module.default,
  });

  return {
    path: "/",
    component,
    childRoutes: [
      SchoolLogin(store),
      ChooseRoute(store),
      Platform(store),
      ThirdPartyAuth(store),
      OauthV2(store),
      PageNotFound(store),
      MigrationInProgress(store),
      ToddleLibrary(store),
      UserBlocked(store),
      AppLauncher(store),
      AppDownload(store),
      MobileUnsupportedRedirect(store),
      FamilyRedirect(store),
      StudentRedirect(store),
      TeacherRedirect(store),
      AITutorAwardsDeepLink(store),
      AITutorAwardsNominateDeepLink(store),
      Admissions(store),
      SessionRevoke(store),
      NoMatch(store),
    ],
  };
};

export default createRoutes;
